module.exports = __webpack_public_path__ + "media/assets/icons/checkboxes/check-circle-checked-08b4ea66dbe7b85d4a6b5c6fe85de048.svg";